<template>
  <div>
    <aside class="slide-bar">
      <div class="close-mobile-menu">
        <a href="javascript:void(0);" aria-label="close mobile menu" @click="closeSidebar">
          <i class="fas fa-times"></i>
        </a>
      </div>

      <nav class="side-mobile-menu">
        <ul>
          <li>
            <router-link :to="'/'" :class="{ active: $route.path === '/' }" @click.native="closeSidebar">
              {{ $t("header.home") }}
            </router-link>
          </li>

          <li v-for="(row, i) in categories" :key="i" class="parent-item">
            <div class="menu-item">
              <router-link :to="{ name: 'projects', params: { id: row.id } }"
                :class="activeId === row.id ? 'active' : ''" @click.native="handleNavigation(row.id)">
                {{ row.name }}
              </router-link>
              <span v-if="row.childs && row.childs.length > 0" class="toggle-arrow"
                :class="{ 'rotated': expandedRows.includes(row.id) }" @click.stop="toggleSubmenu(row.id)">
                ▼
              </span>
            </div>

            <ul v-if="row.childs && row.childs.length > 0" class="submenu"
              :style="{ display: expandedRows.includes(row.id) ? 'block' : 'none' }">
              <li v-for="(subCategory, index) in row.childs" :key="index">
                <router-link :to="{ name: 'projects', params: { id: subCategory.id } }"
                  :class="activeId === subCategory.id ? 'active' : ''" @click.native="handleNavigation(subCategory.id)">
                  {{ subCategory.name }}
                </router-link>
              </li>
            </ul>
          </li>

          <li class="parent-item">
            <div class="menu-item">
              <router-link to="#" class="">
                {{ $t("app.services") }}
              </router-link>
              <span class="toggle-arrow" :class="{ 'rotated': expandedRows.includes('services') }"
                @click.stop="toggleSubmenu('services')">
                ▼
              </span>
            </div>
            <ul class="submenu" :style="{ display: expandedRows.includes('services') ? 'block' : 'none' }">
              <li>
                <router-link to="/projectNomination" :class="{ active: $route.path === '/projectNomination' }"
                  @click.native="closeSidebar">
                  {{ $t("app.design_a_project") }}
                </router-link>
              </li>
              <li>
                <router-link to="/donationVouchers" :class="{ active: $route.path === '/donationVouchers' }"
                  @click.native="closeSidebar">
                  {{ $t("app.dedicate_a_donation") }}
                </router-link>
              </li>
              <li>
                <router-link to="/volunteerRequest" :class="{ active: $route.path === '/volunteerRequest' }"
                  @click.native="closeSidebar">
                  {{ $t("app.volunteer_request") }}
                </router-link>
              </li>
              <li>
                <a href="javascript:void(0);" @click="openZakatModal" class="submenu-link">
                  {{ $t("app.zakat_calculator") }}
                </a>
              </li>
            </ul>
          </li>

          <li class="parent-item">
            <div class="menu-item">
              <router-link to="/about" class="">
                {{ $t("app.about") }}
              </router-link>
              <span class="toggle-arrow" :class="{ 'rotated': expandedRows.includes('about') }"
                @click.stop="toggleSubmenu('about')">
                ▼
              </span>
            </div>
            <ul class="submenu" :style="{ display: expandedRows.includes('about') ? 'block' : 'none' }">
              <li>
                <router-link to="/news" :class="{ active: $route.path === '/news' }" @click.native="closeSidebar">
                  {{ $t("app.news") }}
                </router-link>
              </li>
              <li>
                <router-link to="/about" :class="{ active: $route.path === '/about' }" @click.native="closeSidebar">
                  {{ $t("app.about_us") }}
                </router-link>
              </li>
              <li>
                <router-link to="/contacts" :class="{ active: $route.path === '/contacts' }"
                  @click.native="closeSidebar">
                  {{ $t("app.contact_us") }}
                </router-link>
              </li>
              <li>
                <router-link to="/videos" :class="{ active: $route.path === '/videos' }" @click.native="closeSidebar">
                  {{ $t("app.videos") }}
                </router-link>
              </li>
              <li>
                <router-link to="/gallery" :class="{ active: $route.path === '/gallery' }" @click.native="closeSidebar">
                  {{ $t("app.gallery") }}
                </router-link>
              </li>
              <li>
                <router-link to="/directors" :class="{ active: $route.path === '/directors' }"
                  @click.native="closeSidebar">
                  {{ $t("app.board_of_directors") }}
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </aside>

    <div id="sidebar-overlay" class="body-overlay" @click="closeSidebar"></div>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  name: "AppSidebar",
  data() {
    return {
      categories: [],
      locale: "ar",
      isMobile: window.innerWidth <= 1199.9,
      activeId: null,
      expandedRows: [],
    };
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.isMobile = window.innerWidth <= 1199.9;
    });

    // ============================================================
    // THE FIX FOR DYNAMIC ROUTES & LOGO CONFLICT
    // ============================================================
    // 1. We use $(document).on() so it works even after route changes.
    // 2. We use '.hamburger-menu > a' to target ONLY the direct link inside the hamburger div.
    //    This prevents it from accidentally selecting the Logo link.
    $(document).off('click.sidebarToggle').on('click.sidebarToggle', '.hamburger-menu > a', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.openSidebar();
    });
  },
  beforeDestroy() {
    // Cleanup listener to prevent memory leaks
    $(document).off('click.sidebarToggle');
  },
  created() {
    if (localStorage.getItem("locale")) {
      this.locale = localStorage.getItem("locale");
      this.changeDir(this.locale);
    }
    this.fetchCategories();
    this.activeId = this.$route.params.id ? Number(this.$route.params.id) : null;
    this.setInitialExpandedState();
  },
  watch: {
    // FIX: Watch the entire route object. 
    // This ensures that navigating from /projects to /projects/1 closes the menu
    // and updates the ID properly.
    $route(to, from) {
      this.activeId = to.params.id ? Number(to.params.id) : null;
      this.closeSidebar();
    }
  },
  methods: {
    openSidebar() {
      // FIX: Target specific ID for overlay to avoid double-overlay issue
      $("#sidebar-overlay").addClass("active");
      $(".slide-bar").addClass("show");
      $("body").addClass("on-side");
      $(".hamburger-menu > a").addClass("active");
    },
    closeSidebar() {
      $("#sidebar-overlay").removeClass("active");
      $(".slide-bar").removeClass("show");
      $("body").removeClass("on-side");
      $(".hamburger-menu > a").removeClass("active");
    },
    handleNavigation(id) {
      this.activeId = id;
      this.closeSidebar();
    },
    fetchCategories() {
      const options = {
        url: window.baseURL + "/categories",
        method: "GET",
        params: { locale: this.locale, status: "active" },
      };
      this.$axios(options)
        .then((res) => {
          this.categories = res.data.rows || [];
          this.$nextTick(() => {
            this.setInitialExpandedState();
          });
        })
        .catch(() => {
          this.categories = [];
        });
    },
    changeDir(lang) {
      const body = document.body;
      if (lang === "ar") {
        body.classList.remove("ltr");
        body.classList.add("rtl");
      } else {
        body.classList.add("ltr");
        body.classList.remove("rtl");
      }
    },
    toggleSubmenu(id) {
      const index = this.expandedRows.indexOf(id);
      if (index > -1) {
        this.expandedRows.splice(index, 1);
      } else {
        this.expandedRows.push(id);
      }
    },
    setInitialExpandedState() {
      const activeId = this.activeId;
      if (!activeId) return;
      for (const cat of this.categories) {
        if (cat.id === activeId || (cat.childs && cat.childs.some(c => c.id === activeId))) {
          if (!this.expandedRows.includes(cat.id)) {
            this.expandedRows.push(cat.id);
          }
          break;
        }
      }
    },
    openZakatModal() {
      this.closeSidebar();
      if (typeof window.$ !== 'undefined' && window.$('#Zakat-modal').modal) {
        window.$('#Zakat-modal').modal('show');
      }
    },
  },
};
</script>

<style scoped>
.active {
  color: var(--main-color);
  font-weight: bold;
}

/* Ensure the sidebar transitions nicely */
.slide-bar {
  transition: all 0.4s ease;
}

.active {
  color: var(--main-color);
  font-weight: bold;
}

.parent-item {
  position: relative;
}

.menu-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 8px 0;
}

.menu-item a,
.submenu-link {
  flex: 1;
  text-align: start;
  padding-right: 12px;
  color: inherit;
  text-decoration: none;
  cursor: pointer;
}

.toggle-arrow {
  font-size: 12px;
  min-width: 16px;
  text-align: center;
  cursor: pointer;
  user-select: none;
  transition: transform 0.3s ease;
}

.toggle-arrow.rotated {
  transform: rotate(180deg);
}

.submenu {
  padding-left: 20px;
  margin: 8px 0;
}
</style>